import React from 'react';
import Module from 'Components/Core/Module';
import 'CSS/Member/Member.css';
import './PageStoreGenerator.css';

export default function PageStoreGenerator(props) {

	const x = props.x;
	const [token, setToken] = React.useState(null);
	const [busy, setBusy] = React.useState(false);
	const [resultUrl, setResultUrl] = React.useState('');
	const [error, setError] = React.useState('');

	x.wam.init(props.id, {
		"onClose": () => {}
	});

	React.useEffect(() => {
		x.was.axGet('Backend/webapp.php?module=Member&task=ReadMemberSettings', (result) => {
			setToken(result.data.content.pagestoretoken || '');
			setResultUrl(result.data.content.pagestoreurl || '');
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function copyUrl() {
		navigator.clipboard.writeText(resultUrl).then(
			() => { x.wah.addHint('URL in Zwischenablage kopiert.'); },
			() => { x.wah.addHint('URL konnte nicht kopiert werden.', false); }
		);
	}

	function openSettings() {
		x.wam.openProfile(x.was.memberId, x.was.memberName);
	}

	function generatePage() {
		setBusy(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=PageStore&task=PageStoreGenerate', {}, (result) => {
			setBusy(false);
			if (result.data.returncode === 1) {
				setResultUrl(result.data.content.url);
				x.wah.addHint('Seite wurde erzeugt.');
			}
			else {
				setError(result.data.content.message || 'Seite konnte nicht erzeugt werden.');
				x.wah.addHint('Seite konnte nicht erzeugt werden.', false);
			}
		});
	}

	return (
		<Module id={props.id} x={x} title={props.title} display={props.display} displayTitle="d-block" closeButton="1">
			<div className="page-store-generator settings">
				<div className="settings-card page-store-generator-card">
					<div className="page-store-generator-header">
						<span className="page-store-generator-badge"><i className="bi bi-magic"></i></span>
						<h3 className="settings-card-title">Meine interaktive Seite</h3>
					</div>
					<p className="page-store-generator-description">
						Hier kannst Du aus Deinen Rubriken und Seiten eine eigenständige, interaktive HTML-Seite
						erzeugen lassen. Es werden ausschließlich Deine eigenen Einträge berücksichtigt - Rubriken/Seiten
						mit dem Merkmal "Inaktiv" werden dabei komplett ignoriert, "Versteckt" markierte Einträge
						erscheinen nicht in der Kachel-Ansicht, sind aber weiterhin über die Suche auffindbar.
					</p>
					{ token === '' &&
						<p className="page-store-generator-hint">
							<i className="bi bi-info-circle"></i> Du hast noch keinen Token vergeben. Er wird als Adresse
							Deiner Seite verwendet - lege ihn zuerst in den{' '}
							<button type="button" className="btn-link" onClick={openSettings}>Einstellungen</button> an.
						</p>
					}
					<button type="button" className="btn page-store-generator-generate" disabled={!token || busy} onClick={generatePage}>
						<i className="bi bi-magic"></i>{busy ? 'Seite wird erzeugt…' : 'Seite erzeugen'}
					</button>
					{ error !== '' &&
						<p className="page-store-generator-error">
							<i className="bi bi-exclamation-triangle"></i> {error}
						</p>
					}
					{ resultUrl !== '' &&
						<div className="page-store-generator-url-bar">
							<span className="page-store-generator-url-text" title={resultUrl}>{resultUrl}</span>
							{/* Bewusst kein <button>: die globale "button:hover"-Regel (App.css)
								erzwingt per !important Hintergrund-/Textfarbe fuer JEDEN Button
								in der App und liess das Icon beim Hover verschwinden. */}
							<span
								className="page-store-generator-icon-btn"
								role="button"
								tabIndex={0}
								onClick={copyUrl}
								onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyUrl(); } }}
								title="URL in Zwischenablage kopieren"
							>
								<i className="bi bi-clipboard"></i>
							</span>
						</div>
					}
				</div>
			</div>
		</Module>
	)

};
